<template>
    <transition name="slide-fade">
        <div id="cookies-warning" v-cloak v-if="showMsg">
            <div>
                <p>
                    <slot name="text">
                        BY USING THIS WEBSITE, YOU AGREE TO OUR
                    </slot>
                    <slot name="modal-link">
                        <button type="button">COOKIE POLICY</button>
                    </slot>
                </p>
            </div>
            <button type="button" class="cookies-close" @click="setMsgCookie(false)">
                <slot name="close">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.38 24.04" width="15" height="15">
                        <polygon style="fill:#fff" points="23.96 2.47 22.55 1.06 12.69 10.91 2.84 1.06 1.42 2.47 11.28 12.32 1.42 22.18 2.84 23.59 12.69 13.74 22.55 23.59 23.96 22.18 14.11 12.32 23.96 2.47" />
                    </svg>
                </slot>
            </button>
        </div>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                showMsg: false
            }
        },
        methods: {
            getMsgCookie() {
                return (window.$cookies.get('showCookiesMsg') == 'true' || window.$cookies.get('showCookiesMsg') ==
                    null);
            },
            setMsgCookie(value) {
                window.$cookies.set('showCookiesMsg', value, '1m')
                this.showMsg = value
            },
        },
        mounted() {
            this.showMsg = this.getMsgCookie()
        },
    }
</script>

<style lang="scss">
    #cookies-warning {
        position: fixed;
        bottom: 110px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        text-align: center;
        z-index: 1000;
        font-size: .75rem;
        -webkit-box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.55);
        box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.55);

        .cookies-close {
            // position: absolute;
            // top: 0;
            // right: 0;
            // transform: translate(50%, -50%);
            // width: 30px;
            // height: 30px;
            color: #fff;
            white-space: nowrap;
            font-weight: 100;
            font-size: .8125rem;

            svg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

    .slide-fade-enter-active,
    .slide-fade-leave-active {
        transition: all 250ms ease-out;
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateY(100%);
        opacity: 0;
    }

    @media only screen and (max-width: 575px) {}
</style>